!function (root, factory) {

    factory(root, root.app, root.overwatch, root.jQuery);

}(this, function (root, app, overwatch, $) {

    var util = overwatch.util;
    var mobileMapsShown = false;
    var storedScrollPosition = $(window).scrollTop();
    var mobileBackPressed = true;
    //The map type id currently being used as a filter
    var mapFilterID = '';
    //Get the DOM elements of the game maps
    var $maps = $("[data-js=map]");
    //Get the DOM elements of the map types
    var $mapTypes = $("[data-js=maptype]");

    function init() {

        var video = $('#scroll-to-play')[0];
        var visited = 0;
        overwatch.menuScroll.init({
            menuSelector: "#sub-nav-menu",
            timeToHideMs: 5000,
        });

        var allPairs = [];
        $('.map-group:even').each(function () {
            var $currentEven = $(this);
            var $currentEvenMapTypeDescription = $('.map-type-description', $currentEven);
            $currentEvenMapTypeDescription = $currentEvenMapTypeDescription.add($('.map-group:eq(' + ($currentEven.index() + 1) + ') .map-type-description', $currentEven.parent()));

            allPairs.push($currentEvenMapTypeDescription);
        });

        function checkScroll() {
            var rect = video.getBoundingClientRect();
            if (rect.top <= rect.height / 2) {
                if (!visited) {
                    visited = 1;
                    video.play();
                }
            }
        };

        function adjustHeights() {
            allPairs.map(function ($pair) {
                $pair.heightAdjust({ recalculate: true });
            });
        }

        function resetHeights() {
            allPairs.map(function ($pair) {
                $pair.css('height', 'auto');
            });
        }

        // throttle to 30fps
        $(root.document).on('scroll resize', _.throttle(checkScroll, 32));
        $(root).on('resize', _.debounce(function () {
            if (document.body.offsetWidth >= 992) {
                adjustHeights();
            } else {
                resetHeights();
            }
            if (overwatch.util.isSizeAtLeast("md")) {
                $maps.show();
                //If the mobile maps section is still shown, hide it
                if (mobileMapsShown) {
                    hideMapsSection();
                }
                applyMapFilter(mapFilterID);
            }
        }, 500));

        $('.overwatch-trailer').on('click', function (event) {
            var id = $(this).attr('data-yt-id');
            if (!util.mobile() && !util.touch()) {
                event.preventDefault();
                app.helpers.loadVideoIntoFrame(id);
            }
        });

        //Sort the maps alphabetically
        app.util.$sortElements($maps, function (a, b) {
            return a.getAttribute("data-name").toLowerCase().localeCompare(b.getAttribute("data-name").toLowerCase());
        });

        checkScroll();
        adjustHeights();
        setupMaps();
        root.Maps.init();
    };

    function setupMaps() {
        app.util.$sortElements($mapTypes, function (a, b) {
           return a.getAttribute("data-name").toLowerCase().localeCompare(b.getAttribute("data-name").toLowerCase());
        });
        $mapTypes.on("click", function () {
            //SELECT MAP TYPE ELEMENTS
            var id = $(this).data('id');

            //If we're already filtering by this id, remove the filter
            if (id === mapFilterID && overwatch.util.isSizeAtLeast("md")) {
                $maps.show();
                mapFilterID = '';
                $(this).removeClass("map-type-wrapper-active");
                return true;
                //If we're filtering by a different ID, remove the active class from all map type wrapper elements (hard reset)
            } else if (id !== '') {
                $mapTypes.removeClass("map-type-wrapper-active")
            }
            //Give this element the active class and set the active map type for filtering
            $(this).addClass("map-type-wrapper-active");
            mapFilterID = id;
            applyMapFilter(id);
            //Only show the mobile header related to this map type
            $(".mobile-maps-category-header").hide();
            $(".mobile-maps-category-header[data-id=" + id + "]").show();
            showMapsSection();
        });
        $('[data-js="mapsBackButton"]').on("click", function () {
            mobileBackPressed = true;
            history.back();
        });
        //Capture back button and exit mobile maps section instead (if it is shown)
        window.onpopstate = function (e) {
            if (mobileMapsShown) {
                e.preventDefault();
                $mapTypes.removeClass("map-type-wrapper-active")
                //If navigating with IOS swipe, disable transition so that animation doesn't play after the user has swiped to previous state
                if (!mobileBackPressed && navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                    $(".mobile-maps-section").addClass("maps-no-transition");
                    $("#role-section,#maps-section,#abilities-section").addClass("no-transition-maps");
                }
                hideMapsSection();
            }
        }
    }

    function applyMapFilter(id) {
        //FILTER MAP ELEMENTS
        //If there is no filter, show all map types and return
        if (id === "") {
            $maps.show()
            return;
        }
        //Hide all maps
        $maps.hide();
        //Loop over all maps with the data type and show them
        window.mapTypes[id].maps.forEach(function (mapId) {
            $("[data-js=map][data-id=" + mapId + "]").show();
        });
    }

    function showMapsSection() {
        //If not small size
        if (overwatch.util.isSizeAtLeast("md") || mobileMapsShown) {
            return false;
        }
        //If on IOS, add back the nav animation
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $(".mobile-maps-section").removeClass("no-transition-maps");
            $("#role-section,#maps-section,#abilities-section").removeClass("no-transition-maps");
        }
        storedScrollPosition = $(window).scrollTop();
        $(".mobile-maps-section").show(function () {
            $(this).addClass("mobile-maps-section-moveFromLeft");
            $("#role-section,#maps-section,#abilities-section").addClass("mobile-maps-section-moveToRight");
            //When the CSS transition ends, freeze body scrolling
            $("#maps-section").on('transitionend webkitTransitionEnd oTransitionEnd', function () {
                $("body").addClass("freeze-scroll-sm");
            });
            history.pushState({ page: 1 }, "Maps", "#maps");
            mobileMapsShown = true;
        });
    }
    function hideMapsSection() {
        //If not small size
        if (overwatch.util.isSizeAtLeast("md") || !mobileMapsShown) {
            //Navigate back.  This undoes the history manipulation that is caused by showing the maps
            history.back();
        }
        //Remove the css transition end event listener that would otherwise add the freeze-scroll-sm class to the body (see above)
        $("#maps-section").off('transitionend webkitTransitionEnd oTransitionEnd');
        $(".mobile-maps-section").removeClass("mobile-maps-section-moveFromLeft");
        $("#role-section,#maps-section,#abilities-section").removeClass("mobile-maps-section-moveToRight");
        $("body").removeClass("freeze-scroll-sm");
        mobileMapsShown = false;
        mobileBackPressed = false;
        $(window).scrollTop(storedScrollPosition);
    }

    app.extend({ game: { init: init } });
});
